// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 598) return "static/chunks/598-52bf8a44734b6d21.js";
	if (chunkId === 642) return "static/chunks/642-7a2b69bf43bf8fee.js";
	if (chunkId === 347) return "static/chunks/347-53df0ae6f1c5033c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"25":"cf4fb972bd71253c","175":"cd7e8464b42fe324","726":"c9fc002a66f72b2f","807":"ddca28ab771c1983","904":"06119bcffe530b0a"}[chunkId] + ".js";
};